import React from 'react'
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react'
import { ReactChild } from 'data/types/types'
import { useHasLoaded } from 'data/hooks/useHasLoaded'
import { defaultCarouselProps } from '@ama-selections/ui'

type PropTypes = SwiperProps & {
  items?: ReactChild[]
}

const Carousel = ({
  items = [],
  ...swiperProps
}: PropTypes) => {
  const { ref: componentRef, hasLoaded } = useHasLoaded()

  return (
    <div ref={componentRef}>
      {
        hasLoaded
          && <div className="relative min-w-0">
            <Swiper
              {...defaultCarouselProps}
              {...swiperProps}
            >
              {items != undefined
                ? items.map((item: ReactChild, index: number) =>
                  <SwiperSlide key={index} className="h-full max-w-[300px]">
                    {item}
                  </SwiperSlide>,
                )
                : []}
            </Swiper>
          </div>
      }
    </div>

  )
}

export default Carousel
